export default {
  default : '1px', // @todo naming?
  lg      : '2px',
  xlg     : '3px',
};
